import React, { Fragment } from "react";

import img13 from "../../../images/service/E-Commerce Blockchain Development/finance.png";
import img14 from "../../../images/service/E-Commerce Blockchain Development/finance (2).png";
import img15 from "../../../images/service/E-Commerce Blockchain Development/finance (3).png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "DeFi Platform Development",
    content:
      "Build decentralized finance platforms for lending, borrowing, staking, and yield farming without intermediaries.",
  },
  {
    icon: sIcon2,
    title: "Cross-Border Payment Solutions",
    content:
      "Enable instant, low-cost international transactions with blockchain-based payment rails and smart contracts.",
  },
  {
    icon: sIcon3,
    title: "Digital Asset Management",
    content:
      "Create secure platforms for tokenized securities, digital currencies, and asset custody with regulatory compliance.",
  },
];

const benefits = [
  {
    title: "Reduced Transaction Costs",
    description:
      "Eliminate intermediaries and legacy infrastructure to dramatically reduce fees for payments, transfers, and financial operations.",
    icon: sIcon1,
  },
  {
    title: "24/7 Global Operations",
    description:
      "Blockchain networks operate continuously without banking hours, enabling round-the-clock financial services worldwide.",
    icon: sIcon2,
  },
  {
    title: "Enhanced Security",
    description:
      "Cryptographic protocols and distributed consensus mechanisms protect against fraud, hacks, and unauthorized access.",
    icon: sIcon3,
  },
  {
    title: "Financial Inclusion",
    description:
      "Provide banking services to unbanked populations through accessible, smartphone-based decentralized financial applications.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is finance blockchain development?",
    a: "Finance blockchain development creates decentralized financial systems, payment networks, and asset management platforms using distributed ledger technology to improve efficiency and reduce costs.",
  },
  {
    q: "How does blockchain benefit financial services?",
    a: "Blockchain reduces transaction costs, enables 24/7 operations, enhances security, accelerates settlement times, and provides transparent audit trails for all transactions.",
  },
  {
    q: "What is DeFi (Decentralized Finance)?",
    a: "DeFi refers to financial services built on blockchain that operate without traditional intermediaries, offering lending, borrowing, trading, and earning opportunities through smart contracts.",
  },
  {
    q: "Is blockchain secure for financial transactions?",
    a: "Yes—blockchain's cryptographic security, distributed consensus, and immutable records make it highly secure for financial transactions and resistant to fraud and tampering.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function FinanceBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Finance Blockchain Development"
        pagesub="Build the future of finance with secure, decentralized solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Transform{" "}
            <span className="gradient-text">Financial Services</span>{" "}
            with Blockchain
          </>
        }
        subtitle={`Harness blockchain technology to create transparent, efficient financial systems that reduce costs, 
eliminate intermediaries, and provide unprecedented access to global financial services.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Finance Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Finance?"
        image={img14}
        paragraphs={[
          "Blockchain revolutionizes financial services by enabling peer-to-peer transactions, reducing settlement times from days to seconds, and cutting costs by eliminating intermediaries and legacy systems.",
          "From DeFi platforms to cross-border payments, blockchain provides transparency, security, and accessibility that traditional financial infrastructure cannot match, democratizing access to financial services globally.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Core Finance Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Finance"
        image={img15}
        paragraphs={[
          "Traditional financial systems face high transaction fees, slow settlement times, limited accessibility, operational inefficiencies, and single points of failure that create systemic risk.",
          "Blockchain addresses these challenges through decentralization, automation via smart contracts, real-time settlement, and transparent, auditable transaction records accessible to all stakeholders.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Finance"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Finance Blockchain Solutions"
        subtitle="Build secure, efficient financial infrastructure for the digital age"
        features={[
          {
            icon: sIcon1,
            title: "Instant Settlement",
            description:
              "Enable real-time transaction settlement without waiting for clearing houses.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract Automation",
            description:
              "Automate complex financial agreements, derivatives, and payment logic trustlessly.",
          },
          {
            icon: sIcon3,
            title: "Asset Tokenization",
            description:
              "Convert traditional assets into digital tokens for fractional ownership and trading.",
          },
          {
            icon: sIcon4,
            title: "Regulatory Compliance",
            description:
              "Built-in compliance frameworks for KYC, AML, and financial reporting requirements.",
          },
          {
            icon: sIcon5,
            title: "Transparent Audit Trails",
            description:
              "Immutable transaction records provide complete transparency for auditors and regulators.",
          },
          {
            icon: sIcon6,
            title: "Interoperability",
            description:
              "Connect with multiple blockchain networks and traditional financial systems seamlessly.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expertise in DeFi, payments, and financial blockchain solutions",
          "Regulatory compliance and security-first development approach",
          "Proven track record with leading financial institutions",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
